/** @format */

import {shortNumber} from 'helpers/numberHelpers';

import {ChartLabelValue} from '../../model/charts';

const isValueChartLabel = (value: unknown): value is ChartLabelValue => {
  return typeof (value as ChartLabelValue)?.show === 'boolean';
};

interface AreaLabelProps {
  value?: unknown;
  x?: string | number;
  y?: string | number;
  color: string;
}

const AreaLabel = ({color, value, x, y}: AreaLabelProps) => {
  if (typeof x !== 'number' || typeof y !== 'number' || !isValueChartLabel(value)) {
    return null;
  }

  if (!value?.show || value?.value === undefined) {
    return null;
  }

  const {value: valueDisplay, offsetY = 0, offsetX = 0} = value;

  const valueFormatted = shortNumber(valueDisplay);

  return (
    <text
      x={x - offsetX}
      y={y - offsetY}
      className='recharts-text recharts-label'
      textAnchor='middle'
      fill={color}
      fontSize={12}
      fontWeight='400'
    >
      {valueFormatted}
    </text>
  );
};

export {AreaLabel};
